// import { getTotal } from "../utils/gameHelpers";
import { OPERATORS } from "./constants";

// const operators = ["+", "-", "×", "÷"];

const achievements = [];
// Set up Achievement list
// achievements.push({
//   name: "Solved",
//   info: "Reach the target",
//   check: (eq, target) => getTotal(eq) === target,
// });
achievements.push({
  name: "Odd",
  info: "Solve using an odd number of tiles.",
  check: (eq) => ((eq.length + 1) / 2) % 2 === 1,
});
achievements.push({
  name: "Even",
  info: "Solve using an even number of tiles.",
  check: (eq) => ((eq.length + 1) / 2) % 2 === 0,
});
achievements.push({
  name: "Three",
  info: "Solve using a maximum of 3 tiles.",
  check: (eq) => (eq.length + 1) / 2 <= 3,
});
achievements.push({
  name: "Extremes",
  info: "Use the smallest and largest number.",
  check: (eq, target, grid) =>
    eq
      .filter(Number)
      .filter(
        (a) =>
          parseInt(a, 10) === Math.min(...grid) ||
          parseInt(a, 10) === Math.max(...grid)
      ).length === 2,
});
achievements.push({
  name: "Divide & Conquer",
  info: "Solve with at least one use of division.",
  check: (eq) => eq.indexOf("÷") >= 0,
});
achievements.push({
  name: "Smooth Operators",
  info: "Solve using all of the operators at least once.",
  check: (eq) => OPERATORS.every((o) => eq.indexOf(o) >= 0),
});
achievements.push({
  name: "Stay Positive",
  info: "Solve without using subtraction.",
  check: (eq) => eq.indexOf("-") < 0,
});
achievements.push({
  name: "10+",
  info: "Solve using only tiles of 10 and over.",
  check: (eq) =>
    eq.filter(Number).filter((a) => parseInt(a, 10) < 10).length === 0,
});
// achievements.push({
//   name: "Five ways",
//   info: "Reach the target in at least 5 unique ways.",
//   check: (eq, target, grid, solutions) => solutions.length >= 5,
// });
// TODO: No touching

const config = {
  tileLow: 1,
  tileMax: 99,
  targetMin: 100,
  targetMax: 999,
  gridSizes: ["5x4", "4x4", "4x3", "3x3"],
  achievements,
  operators: OPERATORS,
  padding: 4,
  desktop: 768,
  initialState: {
    app: {
      showHowTo: undefined,
      showMobileAchievements: false,
      showMobileSolutions: false,
      gridWidth: 300,
      gridHeight: 300,
      screenWidth: 0,
      screenHeight: 0,
      tabIndex: 0,
      titleScreen: false,
      newGridMenu: null,
      equationDiv: "",
      reviewShown: 0,
    },
    game: {
      target: 0,
      grid: [],
      eq: [],
      eqPos: 0,
      solutions: [],
      cols: 4,
      rows: 3,
      achievementDiff: [],
    },
  },
};

export default config;
